import React, {Component} from 'react';
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import {
    Box,
    TextareaAutosize,
    Typography
} from "@material-ui/core";
import {FormattedMessage, injectIntl} from "react-intl";
import {inject, observer} from "mobx-react";

const style = theme => ({
    root:{
        [theme.breakpoints.up('xl')]: {
            width: '80%',
        },
        width:'100%',
        marginBottom: 40
    },
    textStyle:{
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1.125rem',
        color: '#0d0d0d',
        fontWeight: 600,
    },
    inputStyle: {
        width: '100%',
        padding: '11px 13px',
        borderRadius: 5,
        border: '1px solid #bec3da',
        background: '#fff',
        marginTop:7,
        "&::placeholder": {
            color: '#a3a8af',
            fontWeight: 300
        },
        "&:focus": {
            outline: 'none',
        },
    },
    textareaStyle: {
        width: "100%",
        border: '1px solid #bec3da',
        padding: '11px 13px',
        borderRadius: 5,
        overflowY: 'scroll',
        overflowX: 'hidden',
        resize: 'none',
        marginTop:7,
        "&::placeholder": {
            color: '#a3a8af',
            fontWeight: 300
        },
        "&:focus": {
            outline: 'none',
        },
        "&::-webkit-scrollbar": {
            width: '5px',
            marginRight:10,
        },
        "&::-webkit-scrollbar-thumb": {
            background: '#dbdbdb',
            borderRadius: '10px',
            backgroundClip: 'padding-box',
        },
        "&::-webkit-scrollbar-track": {
            background: 'transparent',
            marginTop: 10,
        },
    },
});
@inject('surveyStore')
@observer
class Paragraph extends Component {
    render() {
        const { classes, surveyStore, intl } = this.props;
        return (
            <div className={classes.root} onClick={this.props.surveyQuestionInit}>
                <Box>
                    <Typography className={classes.textStyle}><FormattedMessage id="subject"/> <span style={{color:'#ff0000'}}>*</span></Typography>
                    <input
                        name="title"
                        type="text"
                        id="title"
                        maxLength="256"
                        placeholder={intl.formatMessage({id: "msg.insert_survey_subject"})}
                        className={clsx(classes.textStyle, classes.inputStyle)}
                        value={surveyStore.survey.title}
                        onChange={(e) => surveyStore.changeSurveyTitle(e.target.value)}
                    />
                </Box>
                <Box mt={3}>
                    <Typography className={classes.textStyle}><FormattedMessage id="descriptions"/></Typography>
                    <TextareaAutosize
                        rows={3}
                        rowsMax={3}
                        maxLength="10000"
                        aria-label="maximum height"
                        placeholder={intl.formatMessage({id: "msg.insert_survey_description"})}
                        value={surveyStore.survey.descriptions}
                        onChange={(e) => surveyStore.changeSurveyDescriptions(e.target.value)}
                        className={clsx(classes.textStyle, classes.textareaStyle)}
                    />
                </Box>
            </div>
        );
    }
}

export default withStyles(style)(injectIntl(Paragraph));